export const SET_ORGANIZATION = 'SET_ORGANIZATION';
export const SET_ORGANIZATION_DOCUMENTS = 'SET_ORGANIZATION_DOCUMENTS';

export const SET_ORGANIZATION_SETTINGS = 'SET_ORGANIZATION_SETTINGS';
